import { v4 as uuidv4 } from 'uuid';
import { fetchApi, fetchFileUpload } from './UserApi';
import {
	EntertainerApplicationContract,
	EntertainerApplicationFormState,
	EntertainerApplicationSubmissionResult,
} from '../Components/EntertainerApplication/EntertainerApplicationTypes';

const scalarFields: Array<keyof EntertainerApplicationFormState> = [
	'EntertainerName',
	'ContactFirstName',
	'ContactLastName',
	'ContactEmailAddress',
	'ContactPrimaryPhoneNumber',
	'EntertainerStreetAddress1',
	'EntertainerStreetAddress2',
	'EntertainerAddressCity',
	'EntertainerAddressState',
	'EntertainerAddressPostcode',
	'EntertainerABN',
	'EntertainerMinimumPerformerCount',
	'EntertainerMaximumPerformerCount',
	'EntertainerWebsite',
	'EntertainerFacebook',
	'EntertainerInstagram',
	'EntertainerSoundcloud',
	'EntertainerYoutubeChannel',
	'EntertainerDescription',
	'EntertainerRequirements',
	'EntertainerInsuranceCompany',
	'EntertainerInsurancePolicyNumber',
	'EntertainerInsuranceExpiry',
	'EntertainerPowerSlotsRequired',
	'EntertainerPerformanceType',
	'botDetector',
];

export function createEntertainerSubmissionKey() {
	return uuidv4();
}

export async function getEntertainerApplicationContract(signal?: AbortSignal) {
	const response = await fetchApi<{ contract: EntertainerApplicationContract }>({
		route: 'entertainer/get-application-contract',
		data: {},
		signal,
		errorMessage: 'Unable to load the entertainer application.',
	});
	return response.data.contract;
}

export async function submitEntertainerApplication(
	form: EntertainerApplicationFormState,
	submissionKey: string,
	signal?: AbortSignal,
) {
	const data = new FormData();
	data.append('submissionKey', submissionKey);

	for (const field of scalarFields) {
		data.append(field, form[field] as string);
	}
	for (const value of form.EntertainerActFormats) data.append('EntertainerActFormats[]', value);
	for (const value of form.EntertainerGenres) data.append('EntertainerGenres[]', value);
	for (const value of form.EntertainerSpecialties) data.append('EntertainerSpecialties[]', value);
	for (const marketId of form.EntertainerAvailability) data.append('EntertainerAvailability[]', String(marketId));
	if (form.customFile) data.append('customFile', form.customFile);

	const response = await fetchFileUpload<EntertainerApplicationSubmissionResult>({
		route: 'entertainer/submit-application',
		data,
		signal,
		errorMessage: 'Unable to submit your application. Please try again.',
	});
	return response.data;
}
